import { z } from 'zod'
import { oc } from '@orpc/contract'

export const removeOrgMemberInputSchema = z.object({
  practitionerId: z.string().min(1),
})

export const removeOrgMemberOutputSchema = z.object({
  success: z.boolean(),
})

export const removeOrgMember = oc
  .route({ method: 'DELETE', path: '/v2/super/members/{practitionerId}' })
  .input(removeOrgMemberInputSchema)
  .output(removeOrgMemberOutputSchema)
